import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { MatSidenav } from '@angular/material/sidenav';

import { CustomerData } from '@app/shared/models/customers/customer-data.model';

@Component({
  selector: 'app-main-sidenav',
  templateUrl: './main-sidenav.component.html',
  styleUrls: ['./main-sidenav.component.scss']
})
export class MainSidenavComponent implements OnInit, OnChanges {
  @ViewChild(MatSidenav, { static: false }) sidenav: MatSidenav;

  @Input() customer: CustomerData;
  @Input() mode = 'over';
  @Input() menuItems = [];

  @Output() logout = new EventEmitter<any>();

  selectedItem: any;

  constructor(private router: Router) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.menuItems && this.menuItems) {
      this.selectedItem = this.menuItems.find((item) => this.router.url.includes(item.path));
    }
  }

  onSelectItem(item) {
    this.selectedItem = this.selectedItem === item ? null : item;
  }

  toggle() {
    this.sidenav.toggle();
  }

  close() {
    this.sidenav.close();
  }

  subItemsVisible(item) {
    return item.subTabs?.reduce((acc, subItem) => acc || subItem.visible, false);
  }

  get hasLinks() {
    return this.menuItems && this.menuItems.length && this.menuItems[0].path;
  }
}
